import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../../constants/image";
import "../../styles/layout/footer.css";

const Footer = () => {
  const ICON_MAP: Record<string, string> = {
    "facebook-Logo": IMAGES.FOOTER.FACEBOOK,
    "twitter-Logo": IMAGES.FOOTER.TWITTER,
    "youtube-Logo": IMAGES.FOOTER.YOUTUBE,
    "evolve-Logo": IMAGES.FOOTER.EVOLVE_LOGO,
  };

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-middle">
          <div className="container-fluid px-3 px-lg-4">
            <div className="row gy-3 gx-lg-4">
              <div className="col-12 col-md-6 col-lg-3">
                <h5 className="footer-title">About PBCCR</h5>
                <p className="footer-text">
                  PBCCR has evolved over time by stabilizing its case-finding
                  practices to generate reliable cancer incidence statistics.
                </p>
                <span>
                  <Link to="/about" className="footer-link footer-link-cta">
                    Learn More -&gt;
                  </Link>
                </span>
              </div>

              <div className="col-6 col-md-3 col-lg-2">
                <h5 className="footer-title">Quick Links</h5>
                <ul className="list-unstyled footer-list">
                  <li>
                    <Link to="/" className="footer-link">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/factsheets" className="footer-link">
                      Factsheets
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-visualization" className="footer-link">
                      Data Visualization
                    </Link>
                  </li>
                  <li>
                    <Link to="/methods" className="footer-link">
                      Methods
                    </Link>
                  </li>
                  <li>
                    <Link to="/initiatives" className="footer-link">
                      Initiatives
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-md-3 col-lg-2">
                <h5 className="footer-title">Resources</h5>
                <ul className="list-unstyled footer-list">
                  <li>
                    <Link to="/about" className="footer-link">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/help" className="footer-link">
                      Help
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact-us" className="footer-link">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use" className="footer-link">
                      Terms of Use
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" className="footer-link">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-12 col-md-3 col-lg-2">
                <h5 className="footer-title">Social Links</h5>
                <div className="footer-social-icons d-flex gap-1">
                  <a
                    href="https://x.com/ci_wia"
                    target="_blank"
                    rel="noreferrer"
                    className="footer-social-link"
                    aria-label="Cancer Institute WIA on X"
                  >
                    <img
                      src={ICON_MAP["twitter-Logo"]}
                      alt="Twitter"
                      className="social-icon"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UClgI0nJ3FZr9xOrnqU4YlBA"
                    target="_blank"
                    rel="noreferrer"
                    className="footer-social-link"
                    aria-label="Cancer Institute WIA on YouTube"
                  >
                    <img
                      src={ICON_MAP["youtube-Logo"]}
                      alt="YouTube"
                      className="social-icon"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/Cancerinstitutewiaadyarchennai"
                    target="_blank"
                    rel="noreferrer"
                    className="footer-social-link"
                    aria-label="Cancer Institute WIA on Facebook"
                  >
                    <img
                      src={ICON_MAP["facebook-Logo"]}
                      alt="Facebook"
                      className="social-icon"
                    />
                  </a>
                </div>
              </div>
              <div className="col-12 col-md-3 col-lg-2 ">
                <div className="footer-title">Powered By</div>
                <a
                  href="https://evolve.co.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-copyright footer-link footer-powered-by text-decoration-none"
                >
                  <img
                    src={ICON_MAP["evolve-Logo"]}
                    alt="Evolve Bizcon"
                    className="footer-powered-by-logo me-1"
                  />
                  Evolve Bizcon
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container-fluid px-3 px-lg-4 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span>
              © PBCCR {new Date().getFullYear()} - All Rights Reserved
            </span>
            <div className="d-flex gap-3 footer-bottom-links">
              <Link to="/terms-of-use" className="footer-link small">
                Terms of Use
              </Link>
              <Link to="/privacy-policy" className="footer-link small">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
